import { Footnote } from 'src/app/models/footnote.model'

export interface Dashboard {
  yield: number
  riskCode: number
  prospectusExpenseRatio: string
  prospectusExpenseRatioAsOfDate: string
  expenseRatioFootnote?: Footnote
  ytdRegular?: string
  ytdMarket?: string
  ytdAsOfDate?: string
  navPrice?: string
  navPriceAsOfDate?: string
  marketPrice?: string
  marketPriceAsOfDate?: string
  minimum?: string
  unitPrice?: string
  unitPriceAsOfDate?: string
  priceChangeAmount?: string
  marketPriceChangeAmount?: string
  yieldNote?: any
  asOfDate?: string
  contentMarketNeutralFootNote: string
  secYieldNonVgFootNote?: any
  closingMarketPrice?: string
}

export class WatchlistsItem {
  wid?: string
  poid?: string
  ticker: string
  category: WatchlistsItemCategories
  label: string
  details?: object
  created?: number
  updated?: number
  settings?: object
  link: string
  cusip: string
  pendingDelete?: boolean
}

export enum WatchlistsItemCategories {
  DEFAULT = 'DEFAULT',
  VanguardMutualFund = 'Mutual Fund',
  VanguardETF = 'ETF',
  Securities = 'Stock',
  Other = 'Other',
}
